import React from 'react';
import { TextField, Slider, Box, Typography } from '@material-ui/core';
import { VariableEditorProps } from '../types';

export const NumberEditor: React.FC<VariableEditorProps> = ({
  variable,
  value,
  onChange,
  error,
  disabled,
}) => {
  const numValue = value !== undefined && value !== '' ? Number(value) : '';

  // Check for min/max validation
  const rangeRule = variable.validation?.find(v => v.min !== undefined || v.max !== undefined);
  const min = rangeRule?.min;
  const max = rangeRule?.max;

  // Use slider if we have both min and max with reasonable range
  const useSlider =
    min !== undefined &&
    max !== undefined &&
    max - min <= 100 &&
    max - min > 0;

  if (useSlider) {
    return (
      <Box>
        <Typography variant="body2" gutterBottom>
          {variable.name}
          {variable.required && <span style={{ color: 'red' }}> *</span>}
        </Typography>
        <Box display="flex" alignItems="center" style={{ gap: 16 }}>
          <Slider
            value={numValue === '' ? min : (numValue as number)}
            onChange={(_, newValue) => onChange(newValue)}
            min={min}
            max={max}
            step={1}
            marks={[
              { value: min, label: String(min) },
              { value: max, label: String(max) },
            ]}
            valueLabelDisplay="auto"
            disabled={disabled}
            style={{ flex: 1 }}
          />
          <TextField
            size="small"
            variant="outlined"
            type="number"
            value={numValue}
            onChange={e => onChange(e.target.value === '' ? '' : Number(e.target.value))}
            error={!!error}
            disabled={disabled}
            style={{ width: 80 }}
            inputProps={{ min, max }}
          />
        </Box>
        {(error || variable.description) && (
          <Typography
            variant="caption"
            color={error ? 'error' : 'textSecondary'}
          >
            {error || variable.description}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      label={variable.name}
      type="number"
      value={numValue}
      onChange={e => onChange(e.target.value === '' ? '' : Number(e.target.value))}
      error={!!error}
      helperText={error || variable.description}
      disabled={disabled}
      placeholder={
        variable.currentValue !== undefined
          ? `Current: ${variable.currentValue}`
          : variable.default !== undefined
            ? `Default: ${variable.default}`
            : undefined
      }
      inputProps={{
        min,
        max,
      }}
    />
  );
};
